import { TransmissionState } from '../models/transmission-status-information.model';

const transmissionStates: TransmissionState[] = [
  {
    transmissionStatusId: 1,
    transmissionStatusTag: 'inMotion',
    transmissionStatusColor: '#007e00',
    transmissionStatusName: 'Unidad en movimiento',
  },
  {
    transmissionStatusId: 2,
    transmissionStatusTag: 'idleWithIgnitionOn',
    transmissionStatusColor: '#006bb3',
    transmissionStatusName: 'Unidad detenida con ignición',
  },
  {
    transmissionStatusId: 3,
    transmissionStatusTag: 'idleWithoutIgnition',
    transmissionStatusColor: '#7a1fa2',
    transmissionStatusName: 'Unidad detenida sin ignición',
  },
  {
    transmissionStatusId: 4,
    transmissionStatusTag: 'noTransmission',
    transmissionStatusColor: '#2b2b2b',
    transmissionStatusName: 'Unidad sin transmisión',
  },
  {
    transmissionStatusId: 5,
    transmissionStatusTag: 'noSignalCoverage',
    transmissionStatusColor: '#c45b00',
    transmissionStatusName: 'Unidad sin cobertura',
  },
  {
    transmissionStatusId: 6,
    transmissionStatusTag: 'gpsError',
    transmissionStatusColor: '#b20000',
    transmissionStatusName: 'Unidad con error de GPS',
  },
  {
    transmissionStatusId: 0,
    transmissionStatusTag: 'undefined',
    transmissionStatusColor: '#666666',
    transmissionStatusName: 'Unidad no definida',
  },
];

export const getTransmissionStateById = (transmissionStatusId: number) => {
  return transmissionStates.find(
    (state) => state.transmissionStatusId === transmissionStatusId
  );
};

export const getTransmissionStateByTag = (transmissionStatusTag: string) => {
  return transmissionStates.find(
    (state) => state.transmissionStatusTag === transmissionStatusTag
  );
};
